const WhatsAppButton = () => {
  const phoneNumber = '34629482566';
  const message = encodeURIComponent('Hola, me gustaría solicitar información sobre sus servicios de ayuda a domicilio.');
  
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer group"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
      <span className="absolute right-16 bg-gray-900 text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        ¿Necesitas ayuda?
      </span>
    </button>
  );
};

export default WhatsAppButton;